module.exports = __webpack_public_path__ + "assets/arrow.32d96647.svg";